import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'
import React from 'react'

import {getAssetUrl} from '../../../../../../utils'
import {NddDownloadButtonContainer} from '../DownloadButton/NddDownloadButton.container'
import workInProgressImage from './assets/image.svg'
import styleClasses from './classes.module.css'

type Props = {
  country: string
  tariff: string
}

export function WorkInProgressScreen(props: Props) {
  const i18n = useI18n()

  return (
    <div className={styleClasses.screen}>
      <img alt="work in progress" className={styleClasses.img} src={getAssetUrl(workInProgressImage)} />
      <Typography className={styleClasses.title} density="normal" level="title4" weight="medium">
        {i18n('tariffs-v3.tariff-info.work-in-progress.title', 'Скачайте файл с информацией о тарифе')}
      </Typography>
      <NddDownloadButtonContainer
        {...props}
        size="m"
        text={i18n('tariffs-v3.tariff-info.work-in-progress.button-text', 'Скачать файл')}
        view="default"
      />
    </div>
  )
}
